import { createSelector } from 'reselect'

const getTrendingTopicsState = (state) => {
  return (state || {}).trendingTopics || null
}

const getTwitterTrends = createSelector(
  [getTrendingTopicsState],
  (state) => {
    return (state || {}).twitter || null
  }
)

const getYouTubeTrends = createSelector(
  [getTrendingTopicsState],
  (state) => {
    return (state || {}).youtube || null
  }
)

const getTikTokTrends = createSelector(
  [getTrendingTopicsState],
  (state) => {
    return (state || {}).tiktok || null
  }
)

const getInstagramTrends = createSelector(
  [getTrendingTopicsState],
  (state) => {
    return (state || {}).instagram || null
  }
)

const getTrendingDate = createSelector(
  [getTrendingTopicsState],
  (state) => {
    return (state || {}).trendingDate || null
  }
)

const getTrendingTopicsExport = createSelector(
  [getTrendingTopicsState],
  (state) => {
    return (state || {}).export || null
  }
)

const makeTwitterTrendsSelector = () => {
  return createSelector(
    [getTwitterTrends],
    twitterTrends => {
      return twitterTrends
    }
  )
}

const makeYouTubeTrendsSelector = () => {
  return createSelector(
    [getYouTubeTrends],
    youtubeTrends => {
      return youtubeTrends
    }
  )
}

const makeTikTokTrendsSelector = () => {
  return createSelector(
    [getTikTokTrends],
    tiktokTrends => {
      return tiktokTrends
    }
  )
}

const makeInstagramTrendsSelector = () => {
  return createSelector(
    [getInstagramTrends],
    instagramTrends => {
      return instagramTrends
    }
  )
}

const makeTrendingDateSelector = () => {
  return createSelector(
    [getTrendingDate],
    trendingDate => {
      return trendingDate
    }
  )
}

const makeTrendingTopicsExportSelector = () => {
  return createSelector(
    [getTrendingTopicsExport],
    trendingTopicsExport => {
      return trendingTopicsExport
    }
  )
}

export {
  makeTwitterTrendsSelector,
  makeYouTubeTrendsSelector,
  makeTikTokTrendsSelector,
  makeInstagramTrendsSelector,
  makeTrendingDateSelector,
  makeTrendingTopicsExportSelector
}
